import { type ComponentPropsWithoutRef, forwardRef, useId } from 'react';

import * as styles from './spotlight.css';

export type SpotlightGroupProps = ComponentPropsWithoutRef<'div'> & {
  /** Group heading shown above its items; omit/empty to render a header-less group. */
  label?: string;
};

/** A labelled bucket of result rows. */
export const SpotlightGroup = forwardRef<HTMLDivElement, SpotlightGroupProps>(
  ({ children, label, ...props }, ref) => {
    // Name the group from the visible heading (aria-labelledby) rather than duplicating
    // the text in an aria-label, so it isn't announced twice.
    const labelId = useId();
    return (
      <div aria-labelledby={label ? labelId : undefined} ref={ref} role="group" {...props}>
        {label ? (
          <div className={styles.groupLabel} id={labelId}>
            {label}
          </div>
        ) : null}
        {children}
      </div>
    );
  }
);

SpotlightGroup.displayName = 'SpotlightGroup';
